import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../component/common/Header';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { ToastContainer ,toast } from 'react-toastify';
import Loader from '../../component/common/Loader';
import ModalWindow from '../../component/common/ModalWindow';
import AddProgrammeDetail from './../../component/etour/AddProgrammeDetail';
import AddDailyAllowanceDetail from './../../component/etour/AddDailyAllowanceDetail';
import AddhotelAccomodation from './../../component/etour/AddhotelAccomodation';
import CONSTANT from '../../constant' ;
import './../../assets/css/_inputStyle.css'
 
import { convert } from "current-currency"
 
import { onChange, setOptions, validateForm, getCookie, getStorage, getDateParts, getTimeParts } from '../../utils';
import { applyEtour, uploadDetailAttachment } from '../../actions/EtourAction';



class ComponentName extends React.PureComponent<any, any>{
    constructor(props: any) {
        super(props);
        const recipients = getStorage(CONSTANT.cookie.recipients);
        this.state = {
            purpose: { name: 'purpose', value: '', error: '', isRequired: true },
            additionalComment: { name: 'additionalComment', value: '', error: '', isRequired: true },
            attachments: { name: 'attachments', value: [], error: '', isRequired: false },
            to: { name: 'to', value: [], options: recipients, error: '', isRequired: true },
            programmeDetail: { name: 'programmeDetail', value: [], error: '', isRequired: true },
            hotelAccomodation: { name: 'hotelAccomodation', value: [], error: '', isRequired: true },
            allowanceDetail: { name: 'allowanceDetail', value: [], error: '', isRequired: true },

            fare: { name: 'fare', value: 0, error: '', isRequired: true },
            dailyAllowance: { name: 'dailyAllowance', value: 0, error: '', isRequired: true },
            conveyenceCharges: { name: 'conveyenceCharges', value: 0 , error: '', isRequired: true },
         
             netUsDollar : {name: 'netUsDollar', value: 0 , error: '', isRequired: true }, 
            netAmount: { name: 'netAmount', value: 0, error: '', isRequired: true },
            advance: { name: 'advance', value:0 , error: '', isRequired: false },
            showLoader: false,
            showModal: false,
            hotelAccomodationModel: false,
            dailyAllowanceModel: false,
            otherClaims: false,

            hotelBills: { name: 'hotelBills', value: 0, error: '', isRequired: false },
            insurance: { name: 'insurance', value: 0, error: '', isRequired: false },
            dontKnow: { name: 'dontKnow', value: 0, error: '', isRequired: false },
            miscCharges: { name: 'miscCharges', value: 0 , error: '', isRequired: false }
        }
    }

    componentDidMount() {
        window.scrollTo(0 , 0);
        document.title = CONSTANT.pageTitle.etour ;
        convert("INR", 10, "USD").then(res => console.log(res));

    }

     componentDidUpdate (prevProps:any,prevState:any,snapshot:any){
         
        const { programmeDetail  , allowanceDetail ,fare ,dailyAllowance } = this.state
          
         if(prevState.programmeDetail.value.length!= programmeDetail.value.length ){
              
             if(programmeDetail.value.length>0){
                let totalAmout = programmeDetail.value.reduce(function (accumulator: any, currentValue: any) {
                    return accumulator + parseFloat(currentValue.total);
                }, 0);
                 
                onChange(this,this.state.fare.name, totalAmout)
                 
                 if(dailyAllowance.value!=""){
                    totalAmout += parseInt(dailyAllowance.value)  
                 } 
                  
                
                onChange(this,this.state.netAmount.name, totalAmout)
             } 
             
         }

          
         if(prevState.allowanceDetail.value.length!=allowanceDetail.value.length)
         {
            if(allowanceDetail.value.length>0){
                 
                let totalAmout = allowanceDetail.value.reduce(function (accumulator: any, currentValue: any) {
                    return accumulator + parseFloat(currentValue.noOfDaRs);
                }, 0);
 
                onChange(this,this.state.dailyAllowance.name, totalAmout )

                 if(fare.value!=""){
                    totalAmout +=  parseInt(fare.value) 
                 }
                  
                onChange(this,this.state.netAmount.name, totalAmout)
            }
         }

         if(prevState.netAmount.value!=this.state.netAmount.value){
              convert("INR", this.state.netAmount.value, "USD").
              then(res => onChange(this,this.state.netUsDollar.name , res.amount )  )
         }

     }
    render() {
        const { to, purpose, additionalComment, programmeDetail,
            attachments, hotelAccomodationModel, allowanceDetail,
            dailyAllowanceModel, hotelAccomodation, fare, dailyAllowance, conveyenceCharges, netAmount } = this.state;
        const { showLoader, showModal, otherClaims, hotelBills, insurance, dontKnow, miscCharges ,advance ,netUsDollar } = this.state;
        // const totalAmount = Number(fare.value) + Number(dailyAllowance) + Number(conveyenceCharges)

        let totalAmout = programmeDetail.value.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.total);
        }, 0);
         

        let dailyAllowanceTotal = allowanceDetail.value.length > 0 ? allowanceDetail.value.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseInt(currentValue.amountRs);
        }, 0) : 0

        let hotelAccomodationTotal = hotelAccomodation.value.length > 0 ? hotelAccomodation.value.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseInt(currentValue.amountClaimed);
        }, 0) : 0

     
        let HotelBills = hotelBills.value ? hotelBills.value : 0
        let Insurance = insurance.value ? insurance.value : 0
        let DontKnow = dontKnow.value ? dontKnow.value : 0
        let MiscCharges = miscCharges.value ? miscCharges.value : 0
 

        return (
            <div className="container-fluid">
                <div className="row">
                    

                                <ToastContainer
                                position="top-right"
                                autoClose={1000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                />
                                {/* Same as */}
                                <ToastContainer />
                     
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob mb-5'>
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Apply E-tour  </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="card-message">
                                            <form onSubmit={this.onSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Purpose of journey<small>*</small> </label>
                                                            <input
                                                                type="text"
                                                                className={purpose.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder=""
                                                                name={purpose.name}
                                                                value={purpose.value}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <div className="col-md-6"><label>Tour Programme<small>*</small> </label></div>
                                                            <div className="col-md-6 text-end"><button type="button" onClick={this.onShowModal} className="btn btn-link btn-sm">Add an item</button></div>
                                                        </div>
                                                        <div className='list-container'>
                                                        <div className="table-container">
                                                            <div className="table-wrapper radius-4">
                                                            <table className={programmeDetail.error.length > 0 ? "tablen table-danger" : "tablen table-hover"}>
                                                                <thead>
                                                                    <tr className="active">
                                                                        <th style={{ width: '3%' }}>#</th>
                                                                        <th>Start Date</th>
                                                                        <th>End Date</th>
                                                                        <th>From</th>
                                                                        <th>To</th>
                                                                        <th>Mode of travel</th>
                                                                        <th>Fare</th>
                                                                        <th>Total</th>
                                                                        <th style={{ width: '3%' }}></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {
                                                                        programmeDetail.value.length === 0 && <tr>
                                                                            <td colSpan={10} className="text-center">No records found</td>
                                                                        </tr>
                                                                    }

                                                                    {
                                                                        programmeDetail.value.map((item: any, index: number) => {
                                                                            const sdt = getDateParts(item.startDate);
                                                                            const stm = getTimeParts(item.startTime);
                                                                            const edt = getDateParts(item.endDate);
                                                                            const etm = getTimeParts(item.endTime);
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>
                                                                                        {`${sdt.date} ${sdt.monthName} ${sdt.year} ${stm.hour}:${stm.minute} ${stm.amOrpm}`}
                                                                                    </td>
                                                                                    <td>
                                                                                        {`${edt.date} ${edt.monthName} ${edt.year} ${etm.hour}:${etm.minute} ${etm.amOrpm}`}
                                                                                    </td>
                                                                                    <td>{item.from}</td>
                                                                                    <td>{item.to}</td>
                                                                                    <td>{item.modeOfTravel}</td>
                                                                                    <td>{CONSTANT.static.currencySymbol} {parseFloat(item.fare).toLocaleString(CONSTANT.static.locale)}</td>
                                                                                    {/* <td>{CONSTANT.static.currencySymbol} {parseFloat(item.da).toLocaleString(CONSTANT.static.locale)}</td> */}
                                                                                    <td>{CONSTANT.static.currencySymbol} {parseFloat(item.total).toLocaleString(CONSTANT.static.locale)}</td>
                                                                                    <td>
                                                                                        <button type="button" className="btn btn-link text-danger" onClick={this.onDelete} data-id={item.id}>
                                                                                            <i className="fa fa-trash-o pe-none" aria-hidden="true"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                    <tr>
                                                                        <td colSpan={8}>Total</td>
                                                                        <td colSpan={2} className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalAmout).toLocaleString(CONSTANT.static.locale)}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>


                                                    {/* daily allowance entities */}

                                                    <div className="col-md-12 pt-4">
                                                        <div className='row'>
                                                        <div className="col-md-6"><label> Detail of Hotel Accomodation <small>*</small> </label></div>
                                                        <div className="col-md-6 text-end"><button type="button" onClick={this.showDetailAccomodationModel} className="btn btn-link btn-sm">Add Stays</button></div>
                                                        </div>
                                                        <div className='list-container'>
                                                        <div className="table-container">
                                                            <div className="table-wrapper radius-4">
                                                        <table className={hotelAccomodation.error.length > 0 ? "tablen table-hover table-danger" : "tablen table-hover"}>
                                                            <thead>
                                                                <tr className="active">
                                                                    <th style={{ width: '3%' }}>#</th>
                                                                    <th>Class</th>
                                                                    <th>Station</th>
                                                                    <th>Name of Hotel</th>
                                                                    <th>Period of Stay</th>
                                                                    <th>Amount Claimed</th>
                                                                    <th>From Date</th>
                                                                    <th>To Date</th>
                                                                    <th>Remarks</th>
                                                                    <th>Amount Claimed</th>

                                                                    <th style={{ width: '3%' }}></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {
                                                                    hotelAccomodation.value.length === 0 && <tr>
                                                                        <td colSpan={11} className="text-center">No records found</td>
                                                                    </tr>
                                                                }

                                                                {
                                                                    hotelAccomodation.value.map((item: any, index: number) => {
                                                                        const sdt = getDateParts(item.fromDate);
                                                                        const edt = getDateParts(item.toDate);
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>

                                                                                <td>{item.stationClass}</td>
                                                                                <td>{item.station}</td>
                                                                                <td>{item.nameOfHotel}</td>
                                                                                <td>{item.periodOfStay}</td>
                                                                                <td>
                                                                                    {`${sdt.date} ${sdt.monthName} ${sdt.year} ${sdt.hour}:${sdt.minute} ${sdt.amOrpm}`}
                                                                                </td>
                                                                                <td>
                                                                                    {`${edt.date} ${edt.monthName} ${edt.year} ${edt.hour}:${edt.minute} ${edt.amOrpm}`}
                                                                                </td>
                                                                                <td>{item.remarks}</td>
                                                                                <td>{CONSTANT.static.currencySymbol} {parseFloat(item.amountClaimed).toLocaleString(CONSTANT.static.locale)}</td>
                                                                                <td>
                                                                                    <button type="button" className="btn btn-link text-danger" onClick={this.onDelete} data-id={item.id}>
                                                                                        <i className="fa fa-trash-o pe-none" aria-hidden="true"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                 
                                                                  
                                                                <tr> 
                                                                    <td colSpan={10}>Total</td>
                                                                    <td colSpan={2} className="font-weight-bold">   {CONSTANT.static.currencySymbol} {parseFloat(hotelAccomodationTotal).toLocaleString(CONSTANT.static.locale)}    </td>
                                                                 </tr>
                                                                  
                                                            </tbody>
                                                        </table>
                                                        </div>
                                                        </div>
                                                        </div>
                                                    </div>

                                                    {/* daily allowance entities */}
                                                    <div className="col-md-12 py-4">
                                                        <div className='row'>
                                                        <div className="col-md-6"><label> Daily Allowance Entities <small>*</small> </label></div>
                                                        <div className="col-md-6 text-end"><button type="button" onClick={this.showDailyAllowanceModal} className="btn btn-link btn-sm">Add Stays</button></div>
                                                        </div>
                                                        <div className='list-container'>
                                                        <div className="table-container">
                                                            <div className="table-wrapper radius-4">
                                                        <table className={allowanceDetail.error.length > 0 ? "tablen table-hover table-danger" : "tablen table-hover"}>
                                                            <thead>
                                                                <tr className="active">
                                                                    <th style={{ width: '3%' }}>#</th>
                                                                    <th>Class</th>
                                                                    <th>Station</th>
                                                                    <th>No. of DAs</th>
                                                                    <th>No.of DA Rs.</th>
                                                                    <th>Days</th>
                                                                    <th>Total</th>
                                                                    <th style={{ width: '3%' }}></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {
                                                                    allowanceDetail.value.length === 0 && <tr>
                                                                        <td colSpan={8} className="text-center">No records found</td>
                                                                    </tr>
                                                                }
                                                                 
                                                                {
                                                                    allowanceDetail.value.map((item: any, index: number) => {
                                                                        
                                                                         // const sdt = getDateParts(item.startDate);
                                                                        // const stm = getTimeParts(item.startTime);
                                                                        // const edt = getDateParts(item.endDate);
                                                                        // const etm = getTimeParts(item.endTime);
                                                                         
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                {/* <td>
                                                                                    {`${sdt.date} ${sdt.monthName} ${sdt.year} ${stm.hour}:${stm.minute} ${stm.amOrpm}`}
                                                                                </td>
                                                                                <td>
                                                                                    {`${edt.date} ${edt.monthName} ${edt.year} ${etm.hour}:${etm.minute} ${etm.amOrpm}`}
                                                                                </td>
                                                                                <td>{item.from}</td>
                                                                                <td>{item.to}</td> */}
                                                                                <td>{item.stationClass}</td>
                                                                                <td>{item.station}</td>
                                                                                <td>{item.noOfDas}</td>
                                                                                <td>{item.noOfDaRs}</td>
                                                                                <td>{item.days}</td>
                                                                                <td>{item.amountRs}</td>
                                                                                {/* <td>{CONSTANT.static.currencySymbol} {parseFloat(item.fare).toLocaleString(CONSTANT.static.locale)}</td> */}
                                                                                {/* <td>{CONSTANT.static.currencySymbol} {parseFloat(item.da).toLocaleString(CONSTANT.static.locale)}</td> */}
                                                                                {/* <td>{CONSTANT.static.currencySymbol} {parseFloat(item.total).toLocaleString(CONSTANT.static.locale)}</td> */}
                                                                                <td>
                                                                                    <button type="button" className="btn btn-link text-danger" onClick={this.onDelete} data-id={item.id}>
                                                                                        <i className="fa fa-trash-o pe-none" aria-hidden="true"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                <tr>
                                                                    <td colSpan={6}>Total</td>
                                                                    <td colSpan={2} className="font-weight-bold text-end">{CONSTANT.static.currencySymbol} {parseFloat(dailyAllowanceTotal).toLocaleString(CONSTANT.static.locale)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        </div>
                                                        </div>
                                                        </div>
                                                    </div>


                                                    <div className="col-12">

                                                        <label > Calculation of T.A. <small> * </small></label>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label> Fare <small style={{ color: "red" }}> * </small></label>

                                                                {/* <input
                                                                                 // rows={5}
                                                                                  
                                                                                 className={fare.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                                 placeholder=""
                                                                                 name={fare.name}
                                                                                 value={fare.value}
                                                                                 onChange={this.onChange}
                                                                             /> */}

                                                                <input
                                                                    // rows={5}
                                                                    className={fare.error.length > 0 ? 'form-control is-invalid' : 'form-control inputControl'}
                                                                    placeholder=""
                                                                    name={fare.name}
                                                                    value={"₹"+fare.value}
                                                                    max={7}
                                                                //  onChange={this.onChange}
                                                                />
                                                            </div>
                                                            <div className="col-md-4">

                                                                <label> Daily Allowance </label>

                                                                             {/* <input
                                                                                 // rows={5}
                                                                                 className={dailyAllowance.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                                 placeholder=""
                                                                                 name={dailyAllowance.name}
                                                                                 value={dailyAllowance.value}
                                                                                 onChange={this.onChange}
                                                                             /> */}

                                                                <input
                                                                    // rows={5}
                                                                    className={dailyAllowance.error.length > 0 ? 'form-control is-invalid' : 'form-control inputControl'}
                                                                    placeholder=""
                                                                    name={dailyAllowance.name}
                                                                    value={"₹"+dailyAllowance.value}
                                                                    // onChange={this.onChange}
                                                                />

                                                            </div>


                                                            <div className="col-md-4">
                                                                <label> Conveyence charges   </label>

                                                                <input
                                                                    // rows={5}
                                                                    type="number"
                                                                    className={conveyenceCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control inputControl'}
                                                                    placeholder=""
                                                                    name={conveyenceCharges.name}
                                                                    value={conveyenceCharges.value}
                                                                    onChange={this.onChange}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <input type="checkbox" style={{ marginRight: "10px" }} checked={otherClaims} onClick={() => this.setState({ otherClaims: !otherClaims })} />
                                                                <label>Other Claims  <small>*</small> </label>
                                                            </div>
                                                        </div>

                                                        {
                                                             
                                                            otherClaims && <div className="col-12">
                                                                <div className="row">

                                                                    <div className="col-md-6">
                                                                        <label> Hotel Bills   </label>
                                                                        <input
                                                                            // rows={5}
                                                                            type="number"
                                                                            className={hotelBills.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                            placeholder=""
                                                                            name={hotelBills.name}
                                                                            value={hotelBills.value}
                                                                            onChange={this.onChange}
                                                                            maxLength={4}

                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6">

                                                                        <label> Insurance for air travel    </label>

                                                                        <input
                                                                            // rows={5}
                                                                            type="number"
                                                                            className={insurance.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                            placeholder=""
                                                                            name={insurance.name}
                                                                            value={insurance.value}
                                                                            onChange={this.onChange}
                                                                        />
                                                                    </div>


                                                                    <div className="col-12" >
                                                                        <div className="row">
                                                                            <div className="col-md-6"  >
                                                                                <label> Dont know </label>

                                                                                <input
                                                                                    // rows={5}
                                                                                    type="number"
                                                                                    className={dontKnow.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                                    placeholder=""
                                                                                    name={dontKnow.name}
                                                                                    value={dontKnow.value}
                                                                                    onChange={this.onChange}
                                                                                />
                                                                            </div>

                                                                            <div className="col-md-6"  >
                                                                                <label> Misc. Charges  </label>

                                                                                <input
                                                                                    // rows={5}
                                                                                    type="number"
                                                                                    className={miscCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                                    placeholder=""
                                                                                    name={miscCharges.name}
                                                                                    value={miscCharges.value}
                                                                                    onChange={this.onChange}
                                                                                />

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>


                                                            </div>
                                                        }
                                                         
                                                    </div>


                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label> Advance   </label>
                                                            
                                                            <input
                                                                className={advance.error.length > 0 ? 'form-control is-invalid' : 'form-control fareInput'}
                                                                placeholder="Advance"
                                                                name={advance.name}
                                                                value={advance.value}
                                                                onChange={this.onChange}
                                                            />

                                                        </div>
                                                    </div>


                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label> Net Amount  <sup >(fare+D.A.+con.charges-advance)</sup> </label>
                                                            <input
                                                                className={netAmount.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder="Net Amount"
                                                                name={netAmount.name}
                                                                value={"₹"+netAmount.value}
                                                                // onChange={this.onChange}
                                                            />
                                                             
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label> USD (Net Amount)  </label>
                                                            
                                                            <input
                                                                className={netUsDollar.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder="Advance"
                                                                name={"$"+netUsDollar.name}
                                                                value={netUsDollar.value}
                                                            />

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Remarks  </label>

                                                            <textarea
                                                                rows={5}
                                                                className={additionalComment.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder=""
                                                                name={additionalComment.name}
                                                                value={additionalComment.value}
                                                                onChange={this.onChange}
                                                            />

                                                        </div>
                                                    </div>


                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>File(s) <sup>(optional)</sup></label>
                                                            <input
                                                                name={attachments.name}
                                                                onChange={this.onChange}
                                                                type="file"
                                                                multiple={true}
                                                                className="form-control"
                                                                style={{ padding: 4 }}
                                                            />
                                                        </div>
                                                        <div className="mb-3">

                                                            {
                                                                Array.from(attachments.value).map(function (item: any, index: number) {
                                                                    return (
                                                                        <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                                    )
                                                                })
                                                            }

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Recipient <small>*</small> </label>

                                                            <Typeahead
                                                                id="ta-recipient"
                                                                labelKey={(option: any) => `${option.name} - ${option.employeeNumber}`}
                                                                name={to.name}
                                                                value={to.value}
                                                                multiple={false}
                                                                options={to.options}
                                                                onChange={(e: any) => this.typeaheadOnChange(to.name, e)}
                                                                placeholder="Send to"
                                                                isInvalid={to.error.length > 0}
                                                            />
                                                             
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <Link to={CONSTANT.component.userETourList.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                                    </div>
                                                    <div className="col-md-6">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-md-3">
                                                        <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div >
                {
                    showLoader && <Loader />
                }

                
                
                
                  {
                    showModal && <ModalWindow
                        title="Programme Detail"
                        backdrop={false}
                        toggleModal={this.onCancel}>
                         
                        <AddProgrammeDetail
                            onSubmit={this.onAddProgrammeDetailSubmit}
                            onCancel={this.onCancel}
                        />
                         
                    </ModalWindow>
                }

                {
                    dailyAllowanceModel && <ModalWindow
                        title="Daily ALlwoance Entities "
                        backdrop={false}
                        toggleModal={this.onCancel}
                         >
                              
                        <AddDailyAllowanceDetail
                            onSubmit={this.onDailyAllowance}
                            onCancel={this.onCancel}
                        />
                    </ModalWindow>
                }
                
                 
                {
                    hotelAccomodationModel && <ModalWindow
                        title="details of Hotel Accomodation"
                        backdrop={false}
                        toggleModal={this.onCancel}>
                        <AddhotelAccomodation
                            onSubmit={this.onHotelAccomodation}
                            onCancel={this.onCancel}
                        />
                    </ModalWindow>
                }

            </div>
        )
    }
     

    onChange = (e: any) => {
        
        const name = e.target.name;
        let value = e.target.value;

        if (name === this.state.attachments.name) {
            value = e.target.files;
        }
       
         if(name == this.state.conveyenceCharges.name ) {
              if(value!=""){
                let totalFare  = parseInt(this.state.fare.value)  +  parseInt(this.state.dailyAllowance.value) + parseInt(value) -  parseInt(this.state.advance.value)         
                onChange(this,this.state.netAmount.name,totalFare)
                onChange(this,this.state.conveyenceCharges.name,value)
              }else{
                let totalFare  = parseInt(this.state.fare.value)  +  parseInt(this.state.dailyAllowance.value)  -  parseInt(this.state.advance.value)         
                onChange(this,this.state.netAmount.name,totalFare)
                onChange(this,this.state.conveyenceCharges.name,0)
              }
         }

         if(name == this.state.advance.name ) {
              
             if( value!="" ){
                let totalFare  = parseInt(this.state.fare.value) +parseInt(this.state.dailyAllowance.value)
                 + parseInt(this.state.conveyenceCharges.value)   - parseInt(value)
                onChange(this,this.state.netAmount.name,totalFare)
                onChange(this,this.state.advance.name, value )        
            }else{
                let totalFare  = parseInt(this.state.fare.value) + 
                parseInt(this.state.dailyAllowance.value) + parseInt(this.state.conveyenceCharges.value) 
                 
                onChange(this,this.state.netAmount.name,totalFare)
                onChange(this,this.state.advance.name, 0 )             
            }  
        
        }
  
        onChange(this, name, value);
    
     }
      
    typeaheadOnChange = (name: string, e: any) => {
        let value = e;
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
          
        e.preventDefault();
          
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;
            
            const model = {
                to: st.to.value ,
                purpose: st.purpose.value ,
                additionalComment: st.additionalComment.value ,
                 
                programmeDetail: st.programmeDetail.value,
                hotelAccomodation:st.hotelAccomodation.value ,
                allowanceDetail: st.allowanceDetail.value ,
      
                totalFare : st.netAmount.value,
                dailyAllowance : st.dailyAllowance.value ,
                conveyenceCharges :st.conveyenceCharges.value ,
                advance:st.advance.value 

            };

            applyEtour(model).then(async (res: any) => {
                this.setState({ showLoader: false });

                if (res.status === CONSTANT.static.apiStatus.success) {

                    for (let i = 0; i < st.attachments.value.length; i++) {
                        const item = st.attachments.value[i];
                         
                        const itemModel = { eTourCode: res.result.detail.code, attachment: item }
                        
                         await uploadDetailAttachment(itemModel)
                    }
                       
                     
                    toast.success('Etoor Applied', {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                     
                        setTimeout(()=>{
                    this.props.history.push(CONSTANT.component.userETourList.url);
                        } , 2000 )
                     
                     
                } else {
                    alert(res.error.message);
                }
            });
        }

    }

    onShowModal = () => {
        this.setState({ showModal: true });
    }

    showDailyAllowanceModal = () => {
        this.setState({ dailyAllowanceModel: true });
    }

    showDetailAccomodationModel = () => {
        this.setState({ hotelAccomodationModel: true });
    }
    onCancel = () => {
        this.setState({ showModal: false });
        this.setState({ hotelAccomodationModel: false });
        this.setState({ dailyAllowanceModel: false });

    }

    onDelete = (e: any) => {
        const id = parseInt(e.target.dataset.id, 10);
        const isSure = window.confirm('Are you sure, you want to delete this record? ');
        if (isSure) {
            const newProgrammeDetail = this.state.programmeDetail.value.filter((i: any) => i.id !== id);
            onChange(this, this.state.programmeDetail.name, newProgrammeDetail);
        }
    }

    onAddProgrammeDetailSubmit = (model: any) => {
        onChange(this, this.state.programmeDetail.name, [...this.state.programmeDetail.value, model]);
        this.onCancel();
    }

    onHotelAccomodation = (model: any) => {
        onChange(this, this.state.hotelAccomodation.name, [...this.state.hotelAccomodation.value, model]);
        this.onCancel();
    }


    onDailyAllowance = (model: any) => {
        onChange(this, this.state.allowanceDetail.name, [...this.state.allowanceDetail.value, model]);
        this.onCancel();
    }


}

export default ComponentName;


